export const NotFoundPage = () => (
  <div className="p-5 md:p-10">Page not found</div>
);
